import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { Button, Link, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled as styling } from "@mui/material/styles";
import Slider from "react-slick";
import Color from "../../../assets/colors";

// Grid Components //
export const GridContainerStyled = styling(Grid)((props) => ({
  width: "100%",
  padding: "80px 120px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#6658A3",

  [props.theme.breakpoints.between(1280, 1440)]: {
    paddingInline: "120px",
  },

  [props.theme.breakpoints.down(1280)]: {
    padding: "40px 24px 39px 24px",
  },

  [props.theme.breakpoints.down(768)]: {
    padding: "56px 0",
    backgroundColor: "#6658A3",
    flexDirection: "column",
    rowGap: "2rem",
  },
}));

export const InternshipContainer = styling("div")((props) => ({
  width: "100%",
  maxWidth: "1080px",
  height: "545px",
  position: "relative",

  [props.theme.breakpoints.up(1440)]: {
    maxWidth: "1200px",
  },

  [props.theme.breakpoints.down(1280)]: {
    height: "521px",
    maxWidth: "720px",
  },

  [props.theme.breakpoints.down(767)]: {
    minWidth: "312px",
    maxWidth: "100%",
    height: "auto",
  },
}));

export const ParentContainerLeft = styling("div")((props) => ({
  maxWidth: "620px",
  width: "100%",
  height: "521px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: "64px 56px",
  position: "absolute",
  bottom: "0",
  left: "0",
  borderRadius: "1rem",
  border: "2px solid #9B93BA",
  backgroundColor: Color.white,
  zIndex: "2",

  [props.theme.breakpoints.up(1440)]: {
    maxWidth: "740px",
  },

  [props.theme.breakpoints.down(1280)]: {
    padding: "40px 32px",
    height: "497px",
    width: "413px",
  },

  [props.theme.breakpoints.down(768)]: {
    position: "relative",
    padding: "24px",
    maxWidth: "90%",
    margin: "0 auto",
    width: "100%",
    height: "auto",
    borderRadius: "0.5rem",
    gap: "40px",
  },
}));

export const ParentContainerRight = styling("div")((props) => ({
  width: "528px",
  height: "521px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  rowGap: "34px",
  paddingBlock: "54px",
  position: "absolute",
  top: "0",
  right: "0",
  borderRadius: "1rem",
  border: "2px solid #BDCFEE",
  backgroundColor: "#6658A3",
  backgroundImage: props?.bgImage ? `url(${props.bgImage})` : undefined,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  zIndex: "1",

  [props.theme.breakpoints.down(1280)]: {
    width: "352px",
  },

  [props.theme.breakpoints.down(767)]: {
    position: "relative",
    paddingBlock: "0px",
    width: "100%",
    height: "176px",
  },
}));

export const MobilePartnershipContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "0.5rem",
  width: "100%",
}));

export const ChildContainerLeft = styling("div")((props) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "24px",
}));

export const CarouselContainer = styling("div")((props) => ({
  display: "flex",
  width: "100%",
  height: "288px",
  rowGap: "1rem",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
}));

export const UniversityLogoContainer = styling("div")((props) => ({
  display: "inline-flex",
  alignItems: "center",
  columnGap: "2rem",
  height: "60px",
  width: "100%",

  marginRight:
    props?.$margin === 0 ? "80px" : props?.$margin === 2 ? "16px" : "0",
  marginLeft:
    props?.$margin === 1 ? "32px" : props?.$margin === 3 ? "72px" : "0",

  [props.theme.breakpoints.down(1024)]: {
    columnGap: "1.5rem",

    marginLeft: 0,
    marginRight:
      props?.$margin === 0
        ? "176px"
        : props?.$margin === 1
        ? "128px"
        : props?.$margin === 2
        ? "160px"
        : props?.$margin === 3
        ? "144px"
        : "0",
  },
}));

export const SecondSliderContainer = styling("div")((props) => ({
  width: "120%",
  marginLeft: "-10%",
  overflow: "hidden",
}));

export const LogoContainer = styling(Grid)((props) => ({
  display: "flex !important",
  justifyContent: "center",
  alignItems: "center",
  // width: "fit-content !important",
}));

// Typography Components //
export const InternshipTitle = styling(Typography)((props) => ({
  fontFamily: "Georgia",
  fontSize: "40px",
  fontWeight: 400,
  lineHeight: "43.2px",
  color: Color.hiredlyPurple,

  [props.theme.breakpoints.down(1280)]: {
    fontSize: "36px",
  },

  [props.theme.breakpoints.down(768)]: {
    fontSize: "24px",
    lineHeight: "28.8px",
  },
}));

export const InternshipDescription = styling(Typography)((props) => ({
  fontSize: "24px",
  fontWeight: 400,
  lineHeight: "28.8px",
  color: "rgba(0, 0, 0, 0.87)",

  [props.theme.breakpoints.down(1280)]: {
    fontSize: "20px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down(768)]: {
    fontSize: "16px",
    lineHeight: "22.4px",
  },
}));

export const PartnershipsTitle = styling(Typography)((props) => ({
  color: "#ABA1D9",
  textAlign: "center",
  fontWeight: 600,
  lineHeight: "140%",
  width: "270px",
  fontSize: "1.25rem",

  [props.theme.breakpoints.down(1024)]: {
    fontSize: "1rem",
  },

  [props.theme.breakpoints.down(768)]: {
    fontSize: "0.75rem",
    width: "auto",
  },
}));

export const MoreInfoLink = styling(Link)((props) => ({
  fontSize: "20px",
  fontWeight: 700,
  color: "#213DB5",
  lineHeight: "24px",

  [props.theme.breakpoints.down(1024)]: {
    fontSize: "16px",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
}));

export const SliderStyled = styling(Slider)((props) => ({
  width: "100%",
  overflow: "hidden",
  // maxHeight: "50px",
  // maxWidth: "150px",

  "& .slick-track": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxHeight: "80px",
    // columnGap: "72px",
    // columnGap: "0px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    backgroundColor: "#FFDE24",
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const UniversityLogoStyled = styling("img")((props) => ({
  // height: "38px",
  maxWidth: "125px",
  maxHeight: "auto",
  objectFit: "contain",

  opacity: props.$opacity ? "0.5" : "1",
}));

export const LogoStyled = styling("img")((props) => ({
  height: "100%",
  objectFit: "contain",
  display: "grid",
  placeItems: "center",
  maxWidth: "160px",

  // minHeight: "30px",
  // minWidth: "40px",
  backgroundSize: "contain",
  width: "100%",

  // [props.theme.breakpoints.down("lg")]: {
  //   maxHeight: "24px",
  // },
}));

// Icon Components //
export const ArrowIcon = styling(ArrowRightIcon)((props) => ({
  width: "24px",
  height: "24px",
}));

export const ButtonContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  gap: "32px",
  flexDirection: "row",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    flexDirection: "column",
    gap: "24px",
  },
}));
